import { SettingsSectionCard } from "./SettingsSectionCard";
import { TextAreaField, TextField } from "@/components/forms/fields";
import { required, validateCommandJson } from "@/components/forms/validation";
import { validatePort } from "@/lib/utils";
import { containerVerticalFlowAnalytics } from "../analytics";

export const StartCommandAndPortSection: React.FC = () => {
  const handleValidateCommand = (command: string) => validateCommandJson(command);

  const handleValidatePort = (port: string | number | undefined) => {
    if (port === undefined || port === null || port === "") {
      return required(undefined);
    }

    const portNumber = typeof port === "number" ? port : parseInt(String(port), 10);
    if (Number.isNaN(portNumber)) {
      return required(undefined);
    }

    return validatePort(portNumber, true) || undefined;
  };
  return (
    <SettingsSectionCard
      title="Starting Command & Port"
      description="Override container start command and expose required port for web service."
      savedInConfig
    >
      <div className="w-full rounded-lg border border-border">
        <div className="flex flex-col gap-6 p-4">
          <TextAreaField
            label="Start Command (Optional)"
            className="text-grey min-h-10 w-full resize-y"
            name="command"
            baseHOCClassName="pb-0"
            rows={2}
            placeholder='enter command in Json format: e.g. ["python3","-m","vllm.entrypoints.openai.api_server","--model"]'
            validate={handleValidateCommand}
            onBlur={() => containerVerticalFlowAnalytics.trackStartCommandFilled()}
          />
          <TextField
            type="number"
            name="trafficPort"
            label="Port"
            required
            placeholder="e.g. 8000"
            baseHOCClassName="pb-0"
            validate={handleValidatePort}
            disabledOnWheel
            onBlur={() => containerVerticalFlowAnalytics.trackPortFilled()}
          />
        </div>
      </div>
    </SettingsSectionCard>
  );
};
